import { render } from "./OrderConfirmComponent.vue?vue&type=template&id=5c178854&scoped=true"
import script from "./OrderConfirmComponent.vue?vue&type=script&lang=js"
export * from "./OrderConfirmComponent.vue?vue&type=script&lang=js"

import "./OrderConfirmComponent.vue?vue&type=style&index=0&id=5c178854&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.25_vue@3.5.25_typescript@4.9.5__webpack@5.103.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c178854"]])

export default __exports__